import {useEffect, useState} from 'react';

let escapeQueue = 0;

export function useEscape(handler: (event: KeyboardEvent) => void) {
    const [position] = useState(escapeQueue + 1);

    useEffect(() => {
        escapeQueue = position;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (
                event.key.toLowerCase() === 'escape' &&
                escapeQueue === position
            ) {
                handler(event);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            escapeQueue -= 1;
        };
    }, [handler, position]);
}
